import { render, staticRenderFns } from "./UGroupSelect.vue?vue&type=template&id=32437009&"
import script from "./UGroupSelect.vue?vue&type=script&lang=js&"
export * from "./UGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports